import type { MessageDescriptor } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { LinkProps } from "@tanstack/react-router";

export interface DocEntry {
  /** Route path of the documentation page, validated against registered routes. */
  slug: LinkProps["to"];
  title: MessageDescriptor;
  group?: MessageDescriptor;
}

export interface DocGroup {
  id: string | undefined;
  name: MessageDescriptor | undefined;
  entries: Array<DocEntry>;
}

// Order of pages in the navbar is controlled here via `group`, then the order they appear in this array.
export const docsRegistry: Array<DocEntry> = [
  { slug: "/docs", title: msg`Overview`, group: msg`Getting started` },
  // {
  //   slug: "/docs/getting-started/login",
  //   title: msg`Logging in`,
  //   group: msg`Getting started`,
  // },
  {
    slug: "/docs/getting-started/projects",
    title: msg`Projects`,
    group: msg`Getting started`,
  },

  {
    slug: "/docs/property-search",
    title: msg`What is property search?`,
    group: msg`Property search`,
  },
  {
    slug: "/docs/property-search/previous-searches",
    title: msg`Previous searches`,
    group: msg`Property search`,
  },
  {
    slug: "/docs/property-search/select-properties",
    title: msg`Select properties`,
    group: msg`Property search`,
  },
  {
    slug: "/docs/property-search/specify-data-extract",
    title: msg`Specify data extract`,
    group: msg`Property search`,
  },
  {
    slug: "/docs/property-search/property-information",
    title: msg`Viewing property information`,
    group: msg`Property search`,
  },
  {
    slug: "/docs/property-search/costs",
    title: msg`Cost overview`,
    group: msg`Property search`,
  },

  // {
  //   slug: "/docs/downloads",
  //   title: msg`What is downloads?`,
  //   group: msg`Downloads`,
  // },
  // {
  //   slug: "/docs/downloads/underlying-data",
  //   title: msg`Underlying data`,
  //   group: msg`Downloads`,
  // },

  // {
  //   slug: "/docs/data-use/permitted-use",
  //   title: msg`Authorisation and permitted use`,
  //   group: msg`Data use`,
  // },
  // {
  //   slug: "/docs/data-use/traceability",
  //   title: msg`Auditing and traceability`,
  //   group: msg`Data use`,
  // },
  // {
  //   slug: "/docs/data-use/terms-of-use",
  //   title: msg`Terms of use`,
  //   group: msg`Data use`,
  // },

  // {
  //   slug: "/docs/platform/access",
  //   title: msg`Integrate software with REALity`,
  //   group: msg`Platform`,
  // },
  // {
  //   slug: "/docs/platform/design-principles",
  //   title: msg`Technical design principles`,
  //   group: msg`Platform`,
  // },
];

/** Groups consecutive registry entries sharing a group, preserving the exact order of `docsRegistry`. */
export function getDocsSites(): Array<DocGroup> {
  const groups: Array<DocGroup> = [];

  for (const entry of docsRegistry) {
    const last = groups.at(-1);
    let group = last?.id === entry.group?.id ? last : undefined;
    if (!group) {
      group = { id: entry.group?.id, name: entry.group, entries: [] };
      groups.push(group);
    }
    group.entries.push(entry);
  }

  return groups;
}
